import styled, { keyframes } from 'styled-components';

const pulse = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
`;

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

export const Container = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing?.xs ?? '4px'};
  animation: ${fadeIn} 0.3s ease-out;
`;

export const Step = styled.li`
  display: flex;
  align-items: flex-start;
  gap: ${(props) => props.theme.spacing?.sm ?? '8px'};
  font-size: ${(props) => props.theme.fonts?.size?.b2 ?? '14px'};
`;

export const IconWrap = styled.span`
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) =>
    props.$status === 'running'
      ? 'var(--color-primary, #2563eb)'
      : props.$status === 'done'
        ? 'var(--color-success, #22c55e)'
        : 'var(--color-body-muted, #999)'};

  ${(props) =>
    props.$status === 'running' &&
    `
    animation: ${pulse} 1.2s ease-in-out infinite;
  `}
`;

export const Description = styled.span`
  color: ${(props) =>
    props.$status === 'running'
      ? props.theme.colors?.body ?? 'inherit'
      : 'var(--color-body-muted, #666)'};
`;
